import {reducer as toastrReducer} from "react-redux-toastr";
import { combineReducers } from "redux";

import appReducer from "./appReducer";
import appUsersDevicesReducer from "./appUsersDevicesReducer";
import userReducer from "./userReducer";


const reducers = combineReducers({
  appState: appReducer,
  toastr: toastrReducer,
  userState: userReducer,
  appUsersDevicesState: appUsersDevicesReducer
});

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/index.ts